import React from 'react';
import { useTranslation } from 'react-i18next';

import { APP_OPTIONS, NODE_URL_ALIAS_TEAM } from '../../../../../config/constants';
import { createSearchUrl } from '../../../../../helpers/createSearchUrl';
import GenericCard from '../../../../GenericCard';
import type { SearchAllContentHit } from '../../../types';

interface Props {
  hit: SearchAllContentHit;
  className: string;
}

const SearchAllContentResultsHitColleague: React.FC<Props> = (props) => {
  const { hit, className } = props;

  const { t } = useTranslation();

  const link = createSearchUrl({
    pathname: hit.colleague_team_url?.[0] || NODE_URL_ALIAS_TEAM,
    index: APP_OPTIONS.parameters.searchkitIndexTeam,
    value: hit.colleague_full_name?.[0] || '',
  });

  return (
    <GenericCard
      className={className}
      title={hit.colleague_team_title?.[0] || t('components.search_all_content.colleague_hit.title')}
      subtitle={hit.colleague_team_summary?.[0]}
      link={link}
      profile={{
        name: hit.colleague_full_name?.[0],
        image: hit.colleague_profile_picture?.[0],
      }}
    />
  );
};

export default SearchAllContentResultsHitColleague;
